import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_ORDERS = `${BACKEND_BASEURL}api/orders/`;

const createOrder = async (orderData) => {
  const response = await axios.post(API_ORDERS + "createOrder", orderData);
  return response.data;
};

const getOrders = async () => {
  const response = await axios.get(API_ORDERS + "getOrders");
  return response.data;
};

const getOrderLast30Day = async () => {
  const response = await axios.get(API_ORDERS + "getOrderLast30Day");
  return response.data;
};

const getPendingOrders = async () => {
  const response = await axios.get(API_ORDERS + "getPendingOrders");
  return response.data;
};
const getPendingOrdersForupdate = async () => {
  const response = await axios.get(API_ORDERS + "getPendingOrders");
  return response.data;
};
const updateOrderStatus = async ({ updateOrderData, id }) => {
  const response = await axios.patch(
    `${API_ORDERS}/updateOrderStatus/${id}`,
    updateOrderData
  );
  return response.data;
};

const changeTable = async ({ newTableNo, orderId }) => {
  const response = await axios.patch(`${API_ORDERS}/changeTable/${orderId}`, {
    newTableNo,
  });
  return response.data;
};

const updateOrder = async (updateOrderData) => {
  const response = await axios.patch(
    `${API_ORDERS}/updateOrder`,
    updateOrderData
  );
  return response.data;
};

const updateOrderDiscount = async ({
  totalAmountDiscount,
  discountReason,
  id,
  service,
}) => {
  const response = await axios.patch(
    `${API_ORDERS}/updateOrderDiscount/${id}`,
    {
      totalAmountDiscount,
      discountReason,
      service,
    }
  );
  return response.data;
};

const freeOrder = async ({ discountReason, id }) => {
  const response = await axios.patch(`${API_ORDERS}/freeOrder/${id}`, {
    discountReason,
  });
  return response.data;
};

const deleteOrder = async (id) => {
  const response = await axios.delete(`${API_ORDERS}/deleteOrder/${id}`);
  return response.message;
};

const getOrdersByDateTimeRange = async (orderData) => {
  const response = await axios.post(
    API_ORDERS + "getOrdersByDateTimeRange",
    orderData
  );
  return response.data;
};

const OrderServices = {
  createOrder,
  getOrders,
  getOrdersByDateTimeRange,
  getPendingOrders,
  getPendingOrdersForupdate,
  updateOrderStatus,
  changeTable,
  freeOrder,
  deleteOrder,
  updateOrder,
  updateOrderDiscount,
  getOrderLast30Day,
};
export default OrderServices;
